import InputExample from "./InputExample";

export default InputExample;